import { motion } from "framer-motion";

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="absolute left-0 top-0 z-50 w-full p-6 md:p-10"
    >
      <a
        data-testid="nav-logo"
        href="/"
        className="group inline-flex items-baseline gap-3"
        aria-label="Prima Agency home"
      >
        <span className="font-display text-2xl font-bold uppercase leading-none tracking-tight transition-transform duration-300 group-hover:-translate-y-0.5">
          PA
        </span>
        <span className="font-display text-xl font-medium leading-none text-[#1A1F5E]/40">
          /
        </span>
        <span className="text-xs font-bold uppercase leading-none tracking-[0.35em] transition-colors duration-300 group-hover:text-[#1A1F5E]/70">
          Prima Agency
        </span>
      </a>
    </motion.header>
  );
}
